import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import TabPanel from 'components/Tabs/TabPanel';
import POSState from 'features/POSRegisters/interfaces/POSState';
import Device from 'features/POSRegisters/interfaces/Device';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import {POSDeviceScan} from 'features/POSRegisters/interfaces/ScanDetails';
import HeaderTabs, {
  tabsDictionary,
} from 'features/POSRegisters/POSTable/Registers/components/HeaderTabs';
import HeaderTabsType from 'features/POSRegisters/POSTable/Registers/interfaces/Tabs';
import Summary from 'features/POSRegisters/POSTable/Registers/components/Summary';
import Ipads from 'features/POSRegisters/POSTable/Registers/components/Ipads';
import IpadsMini from 'features/POSRegisters/POSTable/Registers/components/IpadsMini';
import ReceiptPrinters from 'features/POSRegisters/POSTable/Registers/components/ReceiptPrinters';
import PaymentTerminals from 'features/POSRegisters/POSTable/Registers/components/PaymentTerminals';
import Anomalies from './components/Anomalies';
import UnsupportedSummary from './components/Summary/RegisterSummary/UnsupportedSummary';

interface RegistersProps {
  state: POSState;
}

function checkForSupportedDevices(devices: Device<POSDeviceScan>[]): boolean {
  return devices.some(device => device.scanResults.isSupported !== false);
}

export default function Registers({state}: RegistersProps) {
  const [selectedTab, setSelectedTab] = useState<HeaderTabsType>(tabsDictionary.SUMMARY);

  return (
    <Grid container>
      <HeaderTabs
        state={state}
        selectedTab={selectedTab}
        handleTabChange={tab => setSelectedTab(tab)}
      />
      <Grid item xs={12}>
        <TabPanel value={selectedTab} index={tabsDictionary.SUMMARY}>
          <Summary {...state} />
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.IPAD_AIR}>
          {checkForSupportedDevices(state.ipads) ? (
            <Ipads ipads={state.ipads} />
          ) : (
            <UnsupportedSummary deviceType={DeviceType.IPAD} />
          )}
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.IPAD_MINI}>
          {checkForSupportedDevices(state.ipadsMini) ? (
            <IpadsMini ipadsMini={state.ipadsMini} />
          ) : (
            <UnsupportedSummary deviceType={DeviceType.IPAD_MINI} />
          )}
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.RECEIPT_PRINTER}>
          {checkForSupportedDevices(state.receiptPrinters) ? (
            <ReceiptPrinters
              receiptPrinters={state.receiptPrinters}
              barcodeScanners={state.barcodeScanners}
              cashDrawers={state.cashDrawers}
            />
          ) : (
            <UnsupportedSummary deviceType={DeviceType.RECEIPT_PRINTER} />
          )}
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.PAYMENT_TERMINAL}>
          {checkForSupportedDevices(state.paymentTerminals) ? (
            <PaymentTerminals paymentTerminals={state.paymentTerminals} />
          ) : (
            <UnsupportedSummary deviceType={DeviceType.PAYMENT_TERMINAL} />
          )}
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.ANOMALIES}>
          <Anomalies {...state} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}
